"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var config_1 = require("./../../config/config");
var lodash_1 = require("lodash");
var Clause = /** @class */ (function () {
    function Clause() {
        this._indent = '';
        this._components = [];
    }
    Object.defineProperty(Clause.prototype, "id", {
        /**
         *
         */
        get: function () {
            return this._id;
        },
        set: function (id) {
            id = this._id;
        },
        enumerable: true,
        configurable: true
    });
    /**
     *
     * @param component
     */
    Clause.prototype.findComponent = function (component) {
        var self = this;
        var srcComponent = component.toString();
        return lodash_1.find(this._components, function (destComponent) {
            if (component instanceof Clause) {
                return srcComponent === destComponent.toString();
            }
            return srcComponent === destComponent;
        });
    };
    /**
     *
     * @param component
     */
    Clause.prototype.removeComponent = function (component) {
        var self = this;
        var srcComponent = component.toString();
        return lodash_1.remove(this._components, function (destComponent) {
            if (component instanceof Clause) {
                return srcComponent === destComponent.toString();
            }
            return srcComponent === destComponent;
        });
    };
    /**
     * Turns the clause into a query string.
     * @return {string} Partial query string.
     */
    Clause.prototype.toString = function () {
        return this.build();
    };
    Clause.prototype.indent = function (initial) {
        this._indent = Array(initial.length + this._indent.length + config_1.INDENT_SIZE + 1).join(' ');
    };
    return Clause;
}());
exports.Clause = Clause;
